define([
    'uiComponent',
    'jquery'
], function (Component, $) {
    'use strict';

    // @deprecated

    return Component.extend({
        /*
         * We want to do 2 things here
         * 1. Trigger an event when a minicart add to cart happens
         * 2. Update our form when a successful cart add happens
         */
        initialize: function (config, element) {
            this._super(config, element);

            if (!element) {
                return;
            }

            $(element).on('submit', function () {
                let formData = new FormData(this);
                $(document).trigger('minicart:addToCart', formData);
            });

            $(document).on('ajax:addToCart', function (e, data) {
                let $el = $(element);

                // This component should be attached to the form that is adding the product
                // Note - Not sure if this is the best way to check though ...
                if ($el.attr('action') !== data.form.attr('action')) {
                    return;
                }

                $el.find('.quick-add-action').addClass('success');
            });
        }
    });
});
